import { call, delay, put } from 'redux-saga/effects'
import { setPageError } from 'store/ui/actions'

export function createTimeoutError (task) {
  const error = new Error('Task polling timed out')
  error.name = 'TimeoutError'
  error.task = task
  return error
}

export const errorWrap = (saga, FAIL_ACTION_CONSTANT, onError) =>
  function * (...args) {
    try {
      yield call(saga, ...args)
    } catch (e) {
      // Properly format errors before logging to avoid "[object XMLHttpRequest]" errors
      if (e?.isAxiosError) {
        console.error(e.toJSON())
      } else if (e instanceof Error) {
        console.error(e)
      } else {
        // Handle cases where e might be a raw XMLHttpRequest or other non-Error object
        console.error('Error:', e)
      }

      if (FAIL_ACTION_CONSTANT) {
        yield put({
          type: FAIL_ACTION_CONSTANT,
          error: e
        })
      }

      if (onError) {
        yield call(onError, e, ...args)
      }
    }
  }

export function * retryUnless (maxRetries, delayMs, noRetryStatuses, fn, ...args) {
  let lastError
  for (let i = 0; i < maxRetries; i++) {
    try {
      return yield call(fn, ...args)
    } catch (e) {
      lastError = e
      if (noRetryStatuses.includes(e?.response?.status)) {
        throw e
      }
      if (i < maxRetries - 1) {
        yield delay(delayMs)
      }
    }
  }
  throw lastError
}

//
// Forward data loading errors to React app
// (e.g. if we received 404 or 500 when loading a resource)
//
export const forwardPageError = (forwardList = [404]) =>
  function * (e) {
    const statusCode = e?.response?.status
    if (forwardList === '*' && statusCode >= 400) {
      yield put(setPageError({ status: statusCode }))
    } else if (forwardList.includes(statusCode)) {
      yield put(setPageError({ status: statusCode }))
    }
  }
